
import React from "react";
import { ArrowRight, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HeroSectionProps {
  title: string;
  description: string;
  ctaText: string;
  imageSrc: string;
  showCalculatorButton?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  description,
  ctaText,
  imageSrc,
  showCalculatorButton = true
}) => {
  const scrollToSection = (e: React.MouseEvent<HTMLButtonElement>, sectionId: string) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    section?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  
  // Extract product name from title for alt text
  const altText = title.includes("Boleto") 
    ? "Dr.Cash Boleto Parcelado - Interface da plataforma" 
    : "Dr.Cash Antecipação - Interface da plataforma";
    
  return <section className="bg-[#072c39] py-12 sm:py-16 md:py-20 lg:py-24 text-white relative overflow-hidden">
      {/* Decorative Elements - Optimized for mobile */}
      <div className="absolute top-0 right-0 w-48 sm:w-72 h-48 sm:h-72 bg-drcash-caribbean-green/10 rounded-full blur-2xl sm:blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 sm:w-96 h-64 sm:h-96 bg-drcash-tiffany-blue/10 rounded-full blur-2xl sm:blur-3xl"></div>
      
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="max-w-xl order-2 md:order-1 text-center md:text-left">
            <h1 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6 leading-tight text-white md:text-3xl my-[28px]">
              {title}
            </h1>
            <p className="text-drcash-cadet-gray mb-6 sm:mb-8 text-base sm:text-lg">
              {description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Button size="sm" variant="default" onClick={e => scrollToSection(e, 'planos')} className="inline-flex items-center justify-center group rounded-full">
                {ctaText}
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
              {showCalculatorButton && <Button size="sm" variant="secondary" onClick={e => scrollToSection(e, 'calculadora-antecipacao')} className="inline-flex items-center justify-center group rounded-full">
                  <Calculator className="mr-2 h-4 w-4" />
                  Calculadora de taxas
                </Button>}
            </div>
          </div>

          <div className="relative order-1 md:order-2 mx-auto md:mx-0">
            <img 
              alt={altText} 
              src={imageSrc}
              loading="eager" 
              className="w-full sm:w-[110%] md:w-[120%] h-auto rounded-lg object-cover" 
            />
          </div>
        </div>
      </div>
    </section>;
};

export default HeroSection;
